<template>
  <b-card
    v-testing="sample"
    class="sampleCompactCard component-inside-1--hover is-cursor-pointer mt-2"
    :class="{'active':isActive, 'disabled':disabled}"
    @click="disabled ? () => {} : $emit('cardSelected')"
  >
    <div
      class="d-flex justify-content-center align-agnoitems-center"
      qa="sample-compact-card-div"
    >
      <span
        class="label-dark"
        qa="sample-compact-card-label-span label-dark"
      >{{ sample }}</span>
    </div>
  </b-card>
</template>

<script>
export default {
    name: 'SampleCompactCard',
    props: {
        sample: { type: String },
        isActive: { type: Boolean },
        isChild: { type: Boolean },
        disabled: { type: Boolean, default: false }
    }
}
</script>

<style lang="scss">
.col-md-auto {
  flex: 0 0 70px;
}
</style>

<style lang="scss" scoped>
.sampleCompactCard {
  height: 40px;
  width: 55px;
}

.sampleCompactCard .card-body {
  display: flex;
  align-items: center;
  justify-content: center;
}

.sampleCompactCard.depleted-card .card-body {
    background: vt-color(depleted-card);
}

.sampleCompactCard span {
  color: vt-color(negative-text);
  font-size: font-size(big);
}

.sampleCompactCard.active .card-body {
  background: vt-color(primary);
}

.sampleCompactCard.active span {
  color: vt-color(white-light) !important;
}
</style>
